const _ = require('lodash');
const {
    russianTld,
    isUkraineRegion,
    ukraineLang,
    ukraineTld,
} = require('app/common/libs/config');
const {REGION_TO_TLD} = require('app/common/libs/region');
const POSTFIX_ONLINE = '-online';

function buildMeta(controller, i18n, params = {}) {
    const {
        pathId,
        channelTitle = '',
        isRussia,
        isSerpApp,
    } = params;

    const region = pathId ? i18n.get('controllers.region', {region: params.region}) : '';
    let i18nPostfixOnline = isRussia ? POSTFIX_ONLINE : '';

    switch (controller) {
        case 'channel':
            const {
                channelSynonyms,
                hasBroadcasting,
            } = params;

            const prefix = i18n.get('channel-controller.prefix');
            const regExp = new RegExp(prefix, 'i');
            const synonyms = channelSynonyms.length ? `, ${channelSynonyms.join(', ')}` : '';
            i18nPostfixOnline = hasBroadcasting ? POSTFIX_ONLINE : '';

            return {
                title: isSerpApp
                    ? i18n.get('channel-controller.serp-app-title')
                    : i18n.get(`channel-controller.title${i18nPostfixOnline}`, {
                        prefix: !regExp.test(channelTitle) ? prefix : '',
                        channel: channelTitle,
                    }),
                description: i18n.get(`channel-controller.description${i18nPostfixOnline}`, {
                    channel: channelTitle,
                }),
                keywords: `${i18n.get('channel-controller.keywords')}, ${channelTitle}${synonyms}`,
            };

        case 'program':
            const {
                programTitle,
                programDescription,
            } = params;

            return {
                title: isSerpApp
                    ? i18n.get('program-controller.serp-app-title')
                    : i18n.get('program-controller.title', {
                        program: programTitle,
                        channel: channelTitle,
                        region,
                    }),
                description: programDescription || i18n.get('program-controller.description'),
                keywords: i18n.get('program-controller.keywords'),
            };

        case 'main':
            const {
                isMain,
                isAllDay,
            } = params;

            return {
                title: i18n.get('main-controller.title', {region}),
                description: i18n.get(
                    `main-controller.description${i18nPostfixOnline}`,
                    {region}
                ).replace(' .', '.'),
                keywords: isMain ? i18n.get('main-controller.keywords', {
                    period: !isAllDay ? i18n.get('main-controller.keywords-period') : '',
                }) : '',
            };

        case 'favorites':
            return {
                title: i18n.get('favorites-controller.title', {region}),
                description: i18n.get('favorites-controller.description'),
                keywords: i18n.get('favorites-controller.keywords'),
            };

        case 'search':
            const {searchText: text} = params;

            return {
                title: i18n.get('search-controller.title', {region, text}),
            };

        case 'tune':
            return {
                title: i18n.get('tune-controller.title'),
            };

        case 'user':
            return {
                title: i18n.get('user-controller.title'),
            };

        case 'stream':
            return {
                title: i18n.get('stream-controller.title', {channel: channelTitle}),
                description: i18n.get('stream-controller.description', {channel: channelTitle}),
                keywords: i18n.get('stream-controller.keywords'),
            };

        case 'online':
            return {
                title: i18n.get('online-controller.title'),
                description: i18n.get('online-controller.description'),
            };

    }
}

/**
 * Альтернативные ссылки
 * @param {Object} req
 * @returns {Object[]}
 */
function buildAlternate(req) {
    const urlBuilder = req.lib('urlBuilder');
    const regionId = urlBuilder.getRegionId();
    const pathname = req.path.split('/').filter(Boolean);
    const query = null;

    if (regionId) {
        pathname.shift();
    }

    const alternateLinks = _.values(REGION_TO_TLD).map(tld => {
        return {
            hreflang: tld === russianTld ? tld : `${russianTld}-${tld.toUpperCase()}`,
            href: urlBuilder.buildUrl(pathname, query, regionId, tld),
        };
    });

    if (isUkraineRegion(regionId)) {
        alternateLinks.push({
            hreflang: ukraineLang,
            href: urlBuilder.buildUrl(pathname, query, regionId, ukraineTld),
        });
    }

    return alternateLinks;
}

module.exports = {
    buildAlternate,
    buildMeta,
};
